export default class ApplicationFormValidation {

    constructor() {
        this.init();
    }

    // -- - -

    init() {


        let $inputs = jQuery('.wp-block-application-form input:required[data-validation], .wp-block-application-form textarea:required[data-validation]');

        function checkFile(thisItem) {
            let maxFileSize = 10; // 10 Mo

            // octet to mo for thisItem.files.item(0).size
            let fileSize = thisItem.files.item(0).size / 1024 / 1024;


            if (fileSize > maxFileSize) {

                // get message error in data-error attribute
                let data_error = thisItem.getAttribute('data-error');
                // if not set, use default message
                if (data_error == null) {
                    data_error = "The file is too large. Please add a file smaller than 10MB.";
                }

                alert(data_error);
                thisItem.value = "";
            }
        }

        let fileInputCV = document.getElementById("input-cv");
        if (fileInputCV) {
            fileInputCV.addEventListener("change", function () {
                checkFile(this);
            });
        }


        let fileInputLetter = document.getElementById("input-letter");
        if (fileInputLetter) {
            fileInputLetter.addEventListener("change", function () {
                checkFile(this);
            });
        }

        let fileResult = document.getElementById("file-result");
        let fileSubmit = document.getElementById("file-submit");

        jQuery('.wp-block-application-form input[type="submit"]').on('click', function (e) {

            // https://stackoverflow.com/questions/46155/how-can-i-validate-an-email-address-in-javascript
            const validateEmail = (email) => {
                return String(email)
                    .toLowerCase()
                    .match(
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    );
            };

            // block l envoi si les champs requis sont KO
            let form_is_valid = true;

            jQuery.each($inputs, function (i, elt) {


                // type ?
                let $the_input = jQuery(elt);
                let validation_type = $the_input.data('validation');
                let input_has_error = false;

                $the_input.removeClass('has--invalid-value');

                if ('text' == validation_type) {
                    if ($the_input.val() == '') {
                        form_is_valid = false;
                        input_has_error = true;
                    }
                }

                if ('email' == validation_type) {
                    if (!Array.isArray(validateEmail($the_input.val()))) {
                        form_is_valid = false;
                        input_has_error = true;
                    }
                }

                if ('file' == validation_type) {
                    if ($the_input.val() == '') {
                        form_is_valid = false;
                        input_has_error = true;
                    }
                }

                if ('checkbox' == validation_type) {
                    if (!$the_input.is(':checked')) {
                        form_is_valid = false;
                        input_has_error = true;
                    }
                }

                if (input_has_error) {
                    $the_input.addClass('has--invalid-value');
                }

            });


            // - -

            if (!form_is_valid) {
                e.preventDefault();
            }


        });

        // - - -

        // clean input if focus in
        $inputs.on('focus', function (e) {
            jQuery(this).removeClass('has--invalid-value');
        });

    }

    // - - -

}